// @flow

import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import mapAsync from 'async/map'
import bindAll from 'lodash/bindAll'
import imgDefaultLogo from '../../../images/public/company_empty.png'
import PublicPagination from '../../partials/PublicPagination'
import $ from 'jquery'
import {
	publicCompaniesFetchData,
	publicCompaniesAddFilterPageNumber,
	publicCompaniesFetchDataAsync
} from '../../../actions/public/companies'

type Props = {
	publicCompanies: Object,
	publicCompaniesFetchData: Function,
	publicCompaniesPagination: Map<string, any>,
	publicCompaniesFilterData: Map<string, any>,
	publicCompaniesAddFilterPageNumber: Function
};

class CompanyList extends React.Component<Props> {
	constructor(props) {
		super(props)

		bindAll(this, [
			'imageOnError'
		])
	}

	componentDidMount() {
		const { publicCompaniesFetchData } = this.props

		publicCompaniesFetchData(this.props.publicCompaniesFilterData)
	}

	imageOnError(title) {
		const {
			publicCompanies
		} = this.props
		$('img[alt="'+title+'"]').attr("src",imgDefaultLogo)
		
		// mapAsync(publicCompanies, (data, callback) => {
		// 	if (data.id === id) {
		// 		data.logoUrl = imgDefaultLogo
		// 	}
		// 	callback(null, data)
		// }, (error, results) => {
		// 	publicCompaniesFetchDataAsync(results)
		// })
	}


	render() {
		const companyList = this.props.publicCompanies.map((data) => (
			<div className="company-list" key={data.id}>
				<Link to={`/public/companies/${data.jobListUrl}`}>
					<div className="logo">
						<img
						src={data.logoUrl}
						alt={data.title}
						onError={this.imageOnError(data.title)} />
					</div>
					<div className="detail">
						<h3>{data.title}</h3>
					</div>
				</Link>
			</div>
		))

		const companyListPagination =
			<PublicPagination
				pagination={this.props.publicCompaniesPagination}
				fetchData={this.props.publicCompaniesFetchData}
				filterData={this.props.publicCompaniesFilterData}
				addPageNumber={this.props.publicCompaniesAddFilterPageNumber} />

		return(
			<div className="company-page">
			  <div className="jumbotron blue-bg">
			    <div className="container">
			      <h2><center>Company List</center></h2>
			    </div>
			  </div>
		    <div className="container">
		      <div className="job-listing">
		        <div className="flex-container flex-start flex-wrap companies">
							{companyList}
		        </div>
		      </div>
		    </div>
				<div className="container">
					<div className="col-md-12 text-center pagination">
						{companyListPagination}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		publicCompanies: state.publicCompanies.toJS(),
		publicCompaniesPagination: state.publicCompaniesPagination.toJS(),
		publicCompaniesFilterData: state.publicCompaniesFilterData.toJS(),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		publicCompaniesFetchData: (filter_data) => dispatch(publicCompaniesFetchData(filter_data)),
		publicCompaniesAddFilterPageNumber: (page) => dispatch(publicCompaniesAddFilterPageNumber(page))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyList)
